module.exports = __webpack_public_path__ + "Flama-Basic.woff?7cf29eac9ef558e5555f03e91b0c931b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Basic.woff
// module id = 894
// module chunks = 0